<template>
  <div class="container-bg-white mt-3">
    <div v-if="!isAdmin">
      <benefits-table
          v-if="activeTab === 'standard'"
          key="standard-benefits"
          :title="standardTitle"
          :items="standardBenefits"
          :current-lang="currentLang"
          :form-data="formData"
          empty-type-key="flexben.benefit_groups.benefit_type_legislated"
          :show-mass-allocate-buttons="true"
          :show-partner-column="true"
          @toggle-benefit-id="toggleBenefitId"
          @mass-allocate="massAllocate"
      />
    </div>

    <div v-else>
      <ul class="nav nav-tabs px-3 pt-3" role="tablist">
        <li class="nav-item">
          <button
              type="button"
              class="nav-link btn btn-link"
              :class="{ active: activeTab === 'standard' }"
              @click="activeTab = 'standard'"
          >
            {{ $t('flexben.benefit_groups.legislated_non_legislated') }}
          </button>
        </li>

        <li class="nav-item">
          <button
              type="button"
              class="nav-link btn btn-link"
              :class="{ active: activeTab === 'custom' }"
              @click="activeTab = 'custom'"
          >
            {{ $t('flexben.benefit_groups.custom_benefits') }}
          </button>
        </li>
      </ul>

      <div>
        <benefits-table
            v-if="activeTab === 'standard'"
            key="standard-benefits"
            :title="standardTitle"
            :items="standardBenefits"
            :current-lang="currentLang"
            :form-data="formData"
            empty-type-key="flexben.benefit_groups.benefit_type_legislated"
            :show-mass-allocate-buttons="true"
            :show-partner-column="true"
            @toggle-benefit-id="toggleBenefitId"
            @mass-allocate="massAllocate"
        />

        <benefits-table
            v-else
            key="custom-benefits"
            :title="$t('flexben.benefit_groups.custom_benefits')"
            :items="customBenefits"
            :current-lang="currentLang"
            :form-data="formData"
            :read-more-ben-id="readMoreBenId"
            empty-type-key="flexben.benefit_groups.custom_benefits"
            @toggle-benefit-id="toggleBenefitId"
            @read-more="readMore"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FlexibleBenefits from "@/components/flexben/benefit_groups/partials/FlexibleBenefits.vue";

export default {
  name: "LegislatedCustomBenefits",

  components: {
    "benefits-table": FlexibleBenefits,
  },

  props: {
    currentLang: {
      type: String,
      default: "ro",
    },
    formAction: {
      type: String,
      required: true,
    },
    benefits: {
      type: Object,
      default: function () {
        return {
          legislated: [],
          custom: [],
          non_legislated: [],
        };
      },
    },
    formData: {
      type: Object,
      default: function () {
        return {
          id: null,
          company: null,
          benefit_type: null,
          name: "",
          code: "",
          is_default: false,
          benefit_ids: [],
        };
      },
    },
  },

  data() {
    return {
      isAdmin: false,
      activeTab: "standard",
      readMoreBenId: null,
    };
  },

  computed: {
    legislatedBenefits() {
      return this.benefits.legislated || [];
    },

    customBenefits() {
      return this.benefits.custom || [];
    },

    nonLegislatedBenefits() {
      return this.benefits.non_legislated || [];
    },

    standardBenefits() {
      return [
        ...this.legislatedBenefits,
        ...this.nonLegislatedBenefits,
      ];
    },

    standardTitle() {
      return this.$t("flexben.benefit_groups.legislated_non_legislated");
    },
  },

  created() {
    this.isAdmin = this.flxUserLevel().userLevel === "admin";
  },

  methods: {
    getBenefitDescription(benefit) {
      if (!benefit.description) {
        return "";
      }

      return benefit.description[this.currentLang] || "";
    },

    toggleBenefitId(benefitId) {
      if (this.formData.benefit_ids.includes(benefitId)) {
        const benefitIndex = this.formData.benefit_ids.indexOf(benefitId);
        this.formData.benefit_ids.splice(benefitIndex, 1);
      } else {
        this.formData.benefit_ids.push(benefitId);
      }
    },

    massAllocate(add, countryId = null) {
      let benefitsToProcess = [];

      if (countryId === -1) {
        benefitsToProcess = this.standardBenefits.filter(item => item.country_id !== 1);
      } else if (countryId !== null) {
        benefitsToProcess = this.standardBenefits.filter(item => item.country_id === countryId);
      } else {
        benefitsToProcess = this.standardBenefits;
      }

      benefitsToProcess.forEach(item => {
        const exists = this.formData.benefit_ids.includes(item.id);

        if (add && !exists) {
          this.formData.benefit_ids.push(item.id);
        }

        if (!add && exists) {
          const indexOfId = this.formData.benefit_ids.indexOf(item.id);
          this.formData.benefit_ids.splice(indexOfId, 1);
        }
      });
    },

    readMore(benefitId) {
      const previousRef = this.$refs["benefit_details_" + this.readMoreBenId];
      const currentRef = this.$refs["benefit_details_" + benefitId];

      if (
          this.readMoreBenId !== benefitId &&
          this.readMoreBenId !== null &&
          previousRef &&
          previousRef[0] &&
          !previousRef[0].classList.contains("text-ellipsis-40")
      ) {
        previousRef[0].classList.add("text-ellipsis-40");
      }

      if (!currentRef || !currentRef[0]) {
        this.readMoreBenId = this.readMoreBenId === benefitId ? null : benefitId;
        return;
      }

      if (currentRef[0].classList.contains("text-ellipsis-40")) {
        currentRef[0].classList.remove("text-ellipsis-40");
      } else {
        currentRef[0].classList.add("text-ellipsis-40");
      }

      this.readMoreBenId = this.readMoreBenId === benefitId ? null : benefitId;
    },
  },
};
</script>